import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'I used to rehearse sentences in my head for 10 minutes before speaking. After the scripts, I just... talk. It sounds stupid but it changed everything.',
  author: 'Andrés M.',
  location: '🇲🇽 Mexico → Toronto, Canada',
  initials: 'AM'
}, {
  quote: "My coworkers used to think I was unfriendly. I wasn't — I was just frozen. The 3-Second Rule alone was worth 10x the price.",
  author: 'Yuki T.',
  location: '🇯🇵 Japan → Sydney, Australia',
  initials: 'YT'
}, {
  quote: 'I made a joke at a work party. People laughed. Real laughs. I cried in the Uber home. This is what I needed.',
  author: 'Fatima A.',
  location: '🇸🇦 Saudi Arabia → London, UK',
  initials: 'FA'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-surface border-t border-border" data-id="element-197">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-199">
          <p className="text-accent-yellow font-bold tracking-widest uppercase text-sm mb-3" data-id="element-200">
            Real Results
          </p>
          <h2 className="font-heading text-5xl md:text-6xl text-primary" data-id="element-201">
            THEY STOPPED <span className="text-accent-yellow" data-id="element-202">NODDING.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-203">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} className="bg-background p-8 rounded-2xl border border-border flex flex-col" data-id="element-204">
              <div className="flex gap-1 text-accent-yellow mb-6" data-id="element-205">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-206" />)}
              </div>
              <p className="text-primary text-lg mb-8 flex-grow italic leading-relaxed" data-id="element-207">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border" data-id="element-208">
                <div className="w-10 h-10 rounded-full bg-accent-yellow/20 flex items-center justify-center text-accent-yellow font-bold text-sm" data-id="element-209">
                  {t.initials}
                </div>
                <div data-id="element-210">
                  <p className="font-bold text-primary text-sm" data-id="element-211">{t.author}</p>
                  <p className="text-xs text-muted" data-id="element-212">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}